import { createContext, FunctionComponent, ReactNode, useContext } from 'react'

type AdditionalProps = object

type OnCloseCallbacks = {
  onBeforeDefaultClose?: () => void
  onAfterDefaultClose?: () => void
}

export type ModalContainerProps = {
  showCloseButton?: boolean
  shouldCloseOnOverlayClick?: boolean
  shouldCloseOnEsc?: boolean
} & OnCloseCallbacks

export type ModalHandler = {
  open: <T extends AdditionalProps>(comp: (props: T) => Promise<ReactNode> | ReactNode, additionalProps: T, containerProps?: ModalContainerProps) => void
  close: () => Promise<void>
}

export type ModalContent<T extends AdditionalProps = AdditionalProps> = {
  Component: FunctionComponent<T>
  additionalProps: T
  containerProps?: ModalContainerProps
}

export const GlobalModalContext = createContext<ModalHandler>({
  open: () => {},
  close: async () => {},
})

export const useModal = () => useContext(GlobalModalContext)
